import { StandaloneServices } from 'monaco-editor/esm/vs/editor/standalone/browser/standaloneServices.js';
import { Registry } from 'monaco-editor/esm/vs/platform/registry/common/platform.js';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api.js';
import { IUserDataProfilesService } from 'monaco-editor/esm/vs/platform/userDataProfile/common/userDataProfile.js';
import { Extensions } from 'monaco-editor/esm/vs/platform/jsonschemas/common/jsonContributionRegistry.js';
import { Emitter, Event } from 'monaco-editor/esm/vs/base/common/event.js';
import { Disposable, extensions } from './api.js';
const registry = ( Registry.as(Extensions.JSONContribution));
function getDefaultSchemaAssociations() {
    const userDataProfilesService = StandaloneServices.get(IUserDataProfilesService);
    const profile = userDataProfilesService.defaultProfile;
    return [{
            fileMatch: [( profile.keybindingsResource.toString(true))],
            uri: 'vscode://schemas/keybindings'
        }, {
            fileMatch: [( profile.settingsResource.toString(true))],
            uri: 'vscode://schemas/settings/user'
        }];
}
function getExtensionSchemaAssociations() {
    const associations = [];
    extensions.all.forEach(extension => {
        const packageJSON = extension.packageJSON;
        const jsonValidation = packageJSON?.contributes?.jsonValidation;
        if (jsonValidation != null) {
            if (Array.isArray(jsonValidation)) {
                jsonValidation.forEach(jv => {
                    let { fileMatch, url } = jv;
                    if (typeof fileMatch === 'string') {
                        fileMatch = [fileMatch];
                    }
                    if (Array.isArray(fileMatch) && typeof url === 'string') {
                        let uri = url;
                        if (uri[0] === '.' && uri[1] === '/') {
                            uri = ( monaco.Uri.joinPath(extension.extensionUri, uri).toString());
                        }
                        fileMatch = ( fileMatch.map(fm => {
                            if (fm[0] === '%') {
                                fm = fm.replace(/%APP_SETTINGS_HOME%/, '/User');
                                fm = fm.replace(/%MACHINE_SETTINGS_HOME%/, '/Machine');
                                fm = fm.replace(/%APP_WORKSPACES_HOME%/, '/Workspaces');
                            }
                            else if (fm.match(/^(\w+:\/\/|\/|!)/) == null) {
                                fm = '/' + fm;
                            }
                            return fm;
                        }));
                        associations.push({ fileMatch, uri });
                    }
                });
            }
        }
    });
    return associations;
}
const customSchemaChangeEmitter = new Emitter();
function getJsonSchemas() {
    return ( Object.entries(registry.getSchemaContributions().schemas)
        .filter(([uri]) => uri !== 'vscode://schemas/vscode-extensions')
        .map(([uri, schema]) => ({
        uri,
        schema
    })));
}
const customJsonSchema = [];
function registerJsonSchema(schema) {
    customJsonSchema.push(schema);
    customSchemaChangeEmitter.fire();
    return new Disposable(() => {
        const index = customJsonSchema.indexOf(schema);
        if (index >= 0) {
            customJsonSchema.splice(index, 1);
            customSchemaChangeEmitter.fire();
        }
    });
}
function synchronizeJsonSchemas() {
    function updateDiagnosticsOptions() {
        monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
            ...monaco.languages.json.jsonDefaults.diagnosticsOptions,
            schemas: [
                ...getJsonSchemas(),
                ...getDefaultSchemaAssociations(),
                ...getExtensionSchemaAssociations()
            ]
        });
    }
    updateDiagnosticsOptions();
    const changeEvent = Event.any(extensions.onDidChange, customSchemaChangeEmitter.event, registry.onDidChangeSchema);
    return changeEvent(updateDiagnosticsOptions);
}
export { registerJsonSchema, synchronizeJsonSchemas };
